module.exports = __webpack_public_path__ + "images/insignia-logod2530d16c5873ee2bfd22933c99323ce.svg";